import { ref, computed, type Ref } from "vue"
import { defineStore } from "pinia"

export const useContextMenuStore = defineStore("contextMenuStore", () => {
  const isContextMenuOpen: Ref<boolean> = ref(false)

  const hasContextMenuOpen = computed(() => {
    return isContextMenuOpen.value
  })

  return {
    isContextMenuOpen,
    hasContextMenuOpen
  }
})
